import axios from "../utils/axios";

export const getSignedUrl = async (filePath) => {
  try {
    const response = await axios.post("/documents/signed-url", {
      filePath,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get signed URL"
    );
  }
};
